/** Central motion helpers. Never hide content with opacity-0 entrance gates. */

export const MOTION_EASE = [0.2, 0, 0, 1] as const;

export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function springTransition():
  | { type: "spring"; stiffness: number; damping: number }
  | { duration: number } {
  if (prefersReducedMotion()) {
    return { duration: 0 };
  }
  return { type: "spring", stiffness: 380, damping: 32 };
}
